import * as React from 'react';
import { Component } from 'react';
import { computed } from 'mobx';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import get from 'lodash/get';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import DynamicLink from './DynamicLink';
import Translate from './Translate';
import { fundListFilter } from '../utils/fundListFilter';
import HTag from './HTag';
import { camelCase } from '@kurtosys/ksys-app-template/dist/utils/changeCase';

const FundCardHeaderWrapper = styled<any, any>('div')`
    ${propStyles};
`;

FundCardHeaderWrapper.defaultProps = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingX: ['md', 'lg'],
    paddingY: ['md', 'lg'],
};

const fundCardLinkDefaultProps = {
    flex: '0 0 auto',
    color: 'white',
    bgColor: 'primary',
    fontFamily: 'heading',
    fontWeight: 'bold',
    fontSize: ['xs', 'sm'],
    textDecoration: 'none',
    textAlign: 'center',
    paddingX: 'md',
    paddingY: 'sm',
    borderRadius: '1em',
};

@inject('dataStore')
@observer
class FundCardHeader extends Component<any, any> {
    @computed
    get fundName() {
        const { nameProperty } = this.props.header;
        return get(
            this.props.shareClass,
            `properties_pub.${nameProperty}.value`
        );
    }

    @computed
    get showLink() {
        const { dataStore, shareClass, header } = this.props;
        return shareClass && fundListFilter(header, dataStore, shareClass);
    }

    @computed
    get fundLinkLabel() {
        const { linkLabel } = this.props.header;
        return linkLabel;
    }

    render() {
        const { fundName, fundLinkLabel, showLink } = this;
        const { header, theme, shareClass, queryContext } = this.props;

        return (
            <FundCardHeaderWrapper {...theme.FundCardHeader}>
                <HTag
                    componentTheme={'FundCardHeading'}
                    defaultStyleProps={{
                        color: 'body',
                        fontFamily: 'body',
                        fontWeight: 'regular',
                        fontSize: ['md', 'lg'],
                        margin: '0 1em 0 0',
                    }}
                    level={1}
                    text={fundName}
                />
                {fundLinkLabel && showLink && (
                    <DynamicLink
                        config={header}
                        shareClass={shareClass}
                        queryContext={queryContext}
                        metricContext={`fundCardHeader-${camelCase(
                            shareClass.clientCode
                        )}`}
                        ariaLabelKey={'fundCardHeaderLink'}
                        {...fundCardLinkDefaultProps}
                        {...theme.FundCardLink}
                    >
                        <Translate>{fundLinkLabel}</Translate>
                    </DynamicLink>
                )}
            </FundCardHeaderWrapper>
        );
    }
}

export default withTheme(FundCardHeader) as any;



// WEBPACK FOOTER //
// ./src/Components/FundCardHeader.tsx